//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[[0,"MarkerLocation",1,0],[0,"PassNumber",1,0],[0,"PassShapeType",1,0],[0,"PatternType",1,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.CAM.PatternMarker = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PatternMarker";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.PatternMarker.Type = Object.freeze({
    "Undefined" : "Undefined", "Finish" : "Finish", "SpringPass" : "SpringPass", "Infill" : "Infill"});

SPLM.CAM.PatternMarker.Location = Object.freeze({
    "Start" : "Start", "End" : "End"});

SPLM.CAM.PatternMarker.ShapeType = Object.freeze({
    "Undefined" : "Undefined", "Outer" : "Outer", "Inner" : "Inner"});

export default SPLM;